webpackJsonp(["conditioner0"],{

/***/ "./src/js/components/collapse.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = collapse;
// Function to create a node list
// of the content between this heading and the next
function getContent($el, level) {
  var $$els = [];
  while ($el.nextElementSibling && $el.nextElementSibling.tagName !== 'H' + level) {
    $$els.push($el.nextElementSibling);
    $el = $el.nextElementSibling;
  }

  // Delete the old versions of the content nodes
  $$els.forEach(function (node) {
    node.parentNode.removeChild(node);
  });

  return $$els;
}

function moveChildren($from, $to) {
  while ($from.childNodes.length) {
    $to.appendChild($from.childNodes[0]);
  }
}

function insertAfter($newNode, $referenceNode) {
  $referenceNode.parentNode.insertBefore($newNode, $referenceNode.nextSibling);
}

function collapse($el) {
  var level = $el.getAttribute('data-level') || '2';
  var $headings = $el.querySelectorAll('h' + level);

  Array.prototype.forEach.call($headings, function ($heading) {
    // Give each heading a toggle button child
    var $btn = document.createElement('button');
    $btn.setAttribute('aria-expanded', 'false');

    moveChildren($heading, $btn);
    $heading.appendChild($btn);

    // Assign the contents to be expanded/collapsed (array)
    var $$contents = getContent($heading, level);

    // Create a wrapper element for `contents` and hide it
    var $wrapper = document.createElement('div');
    $wrapper.hidden = true;

    // Add each element of `contents` to `wrapper`
    $$contents.forEach(function ($node) {
      $wrapper.appendChild($node);
    });

    // Add the wrapped content back into the DOM
    // after the heading
    $heading.parentNode.insertBefore($wrapper, $heading.nextElementSibling);

    $btn.addEventListener('click', function () {
      var expanded = $btn.getAttribute('aria-expanded') === 'true' || false;
      $btn.setAttribute('aria-expanded', !expanded);
      $wrapper.hidden = expanded;
    });
  });

  return function () {
    Array.prototype.forEach.call($headings, function ($heading) {
      var $btn = $heading.firstChild;
      moveChildren($btn, $heading);
      $heading.removeChild($btn);

      var $content = $heading.nextElementSibling;
      while ($content.childNodes.length) {
        insertAfter($content.childNodes[0], $heading);
      }
      $content.parentNode.removeChild($content);
    });
  };
}

/***/ })

});


// WEBPACK FOOTER //
// conditioner0.a3dd89925c609617922d.js